import { ComponentProps } from 'react';
import Tag from 'antd/es/tag';
import clsx from 'clsx';

interface OpTagProps extends ComponentProps<typeof Tag> {
  testId?: string;
}

/**
 * OpTag is a wrapper around Ant Design's Tag component.
 * It displays small, labeled elements for categorizing or marking items.
 *
 * Use this component to display status, categories, labels, or any short piece of information
 * that helps organize or classify content. Supports various colors and closeable tags.
 *
 * @example
 * <OpTag>Default Tag</OpTag>
 * <OpTag color="success">Active</OpTag>
 * <OpTag closable onClose={handleClose}>Removable</OpTag>
 *
 */
export const OpTag = ({
  className,
  testId = 'op-tag',
  ...tagProps
}: OpTagProps) => {
  return (
    <Tag
      className={clsx('op-tag', className)}
      data-testid={testId}
      {...tagProps}
    />
  );
};
